/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/ArticleTeaser/Bodytext/theme';

export const ArticleTeaserBodytextTheme = theme;
